import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

function TermsGate() {
  const { profile, acceptTerms } = useAuth();
  const [loading, setLoading] = useState(false);

  // Don't show if user has already accepted TOS
  // Use strict === null so fallback profiles (tos_accepted_at: undefined) don't trigger
  if (!profile || profile.tos_accepted_at !== null) return null;

  const handleAgree = async () => {
    setLoading(true);
    try {
      await acceptTerms();
    } catch (err) {
      console.error('Error accepting terms:', err);
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-dive-black z-[9998] flex flex-col items-center justify-start p-4 pt-16 overflow-y-auto">
      <div className="max-w-md w-full text-center">
        {/* Logo */}
        <img
          src="/logo-full.png"
          alt="Tilted"
          className="w-[260px] max-w-[70vw] mx-auto mb-4"
        />
        <p className="text-gray-400 mb-8">
          The Dive Bar Community App
        </p>

        {/* TOS Agreement Card */}
        <div className="bg-dive-dark border border-dive-gray rounded-2xl p-6 mb-6">
          <span className="font-bold text-lg text-white mb-4 block">Terms & Privacy</span>

          <p className="text-gray-300 mb-6">
            To continue, please review and agree to our{' '}
            <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-dive-neon underline">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-dive-neon underline">
              Privacy Policy
            </a>.
          </p>

          <button
            onClick={handleAgree}
            disabled={loading}
            className="btn-primary w-full py-4 text-lg disabled:opacity-50"
          >
            {loading ? 'Please wait...' : 'I Agree — Continue to Tilted'}
          </button>
        </div>

        <p className="text-gray-600 text-xs">
          You must be 21 or older to use Tilted. Please drink responsibly.
        </p>
      </div>
    </div>
  );
}

export default TermsGate;
